import React, { useEffect, useRef } from "react";
import styled from "styled-components";
import {
    MELOGY_ALMOST_OPAQUE,
    MELOGY_TRANSPARENT,
} from "../../style/colors";
import { POPOVER_SHADOW } from "../../style/shadows"

const Backdrop = styled.div`
    position: fixed;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: ${MELOGY_TRANSPARENT};
    z-index: ${(props) => props.zIndex};

    ${({ backdropTop }) => backdropTop !== undefined && `top: ${backdropTop};`}
    ${({ backdropHeight }) => backdropHeight !== undefined && `height: ${backdropHeight};`}
`;

const PopoverWrapper = styled.div`
    background-color: ${MELOGY_ALMOST_OPAQUE};
    position: absolute;
    top: ${({ popoverTop }) => popoverTop || "50%"};
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: ${(props) => props.zIndex};
    max-width: min(80vw, 480px);
    box-shadow: ${POPOVER_SHADOW};
    border: 1px solid rgba(128, 128, 128, 0.5);
`;

const PopoverContent = styled.div`
    padding: 16px;
`;

const Popover = ({ content, onClose, zIndex, backdropTop, backdropHeight, popoverTop }) => {
    const popoverRef = useRef();
    const backdropRef = useRef();

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (!backdropRef.current?.contains(event.target)) return;
            if (!popoverRef.current?.contains(event.target)) onClose();
        };        

        const handleEscapeKey = (event) => {
            if (event.key === "Escape") {
                onClose();
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        document.addEventListener("keydown", handleEscapeKey);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
            document.removeEventListener("keydown", handleEscapeKey);
        };
    }, [onClose]);

    return (
        <>
            <Backdrop 
                ref={backdropRef}
                zIndex={zIndex - 1} 
                onClick={onClose} 
                backdropTop={backdropTop} 
                backdropHeight={backdropHeight} 
            />
            <PopoverWrapper 
                ref={popoverRef} 
                zIndex={zIndex}
                popoverTop={popoverTop}
            >    
                <PopoverContent>{content}</PopoverContent>
            </PopoverWrapper>
        </>
    );
};

export default Popover;
